import {
  airBookingApi,
  type AnyResponse,
  type UpdatePassengerRequest,
} from "@b2bportal/air-booking-api";
import { type IApiConfig, NETWORK_CALL_FAILED } from "@hopper-b2b/types";
import { axiosInstance } from "../AxiosInterceptor";
import { trackEvent } from "../tracking/trackEvent";

export const updateUserPassenger = (
  body: UpdatePassengerRequest,
  apiConfig?: IApiConfig
): Promise<AnyResponse> =>
  new Promise((resolve, reject) => {
    airBookingApi(axiosInstance)
      .apiV0FlightPassengersUpdatePut(body)
      .then((res) => {
        const responseBody: AnyResponse = res.data;
        // Check for failure in response body (API returns 200 with Response: "Failure")
        if (responseBody.Response === "Failure") {
          reject(responseBody);
        } else {
          resolve(responseBody);
        }
      })
      .catch((e) => {
        trackEvent(
          {
            eventName: NETWORK_CALL_FAILED,
            properties: {
              url: window.location.pathname,
            },
          },
          apiConfig
        );
        reject(e);
      });
  });
